import { HOUR } from './time.ts';
import type { FestivalSet } from './types.ts';

export function validTimelineSet(set: FestivalSet): boolean {
  return Number.isFinite(set.startTs) && Number.isFinite(set.endTs) && set.endTs > set.startTs;
}

export function timelineRange(sets: FestivalSet[]): { start: number; end: number; hours: number } | null {
  const valid = sets.filter(validTimelineSet);
  if (!valid.length) return null;
  const start = Math.floor(Math.min(...valid.map((set) => set.startTs)) / HOUR) * HOUR;
  const end = Math.ceil(Math.max(...valid.map((set) => set.endTs)) / HOUR) * HOUR;
  return { start, end, hours: (end - start) / HOUR };
}

/** Overlapping imports stay visible without stretching or shifting their times. */
export function timelineLanes(sets: FestivalSet[]): { set: FestivalSet; lane: number }[] {
  const ends: number[] = [];
  return sets.filter(validTimelineSet)
    .sort((a, b) => a.startTs - b.startTs || a.endTs - b.endTs || a.id.localeCompare(b.id))
    .map((set) => {
      const available = ends.findIndex((end) => end <= set.startTs);
      const lane = available < 0 ? ends.length : available;
      ends[lane] = set.endTs;
      return { set, lane };
    });
}
